import React from 'react';
import { DragDropContext, Draggable, DropResult, Droppable } from 'react-beautiful-dnd';
import { StyledPaperContainer, StyledSectionTitle, StyledTextButton } from '../../PlusWebsiteEditor.styles';
import { reorder } from '../../components/DraggableHOC/Draggable.utils';
import { StyledCustomLinksList } from './FooterCustomLinks.styled';
import { FooterCustomLink as IFooterCustomLink, WebsiteConfiguration } from '../../types/websiteConfiguration';
import { FooterCustomLink } from '../../components/FooterCustomLink/FooterCustomLink';
import * as array from '../../utils/array';
import { ArrayErrorGetter, BlurHandler, ChangeHandler } from '../../types/handlers';

type Props = {
  links: WebsiteConfiguration['footer_custom_links'];
  onChange: ChangeHandler<Array<IFooterCustomLink>>;
  onBlur: BlurHandler;
  getError: ArrayErrorGetter<IFooterCustomLink>;
};

const FooterCustomLinks = ({ links = [], onChange, getError, onBlur }: Props) => {
  const handleDragEnd = (result: DropResult) => {
    onChange(reorder(links, result), true);
  };

  const handleAddMore = () => {
    const newCustomLink: IFooterCustomLink = {
      id: (Math.random() * 1000000).toString(),
      title: '',
      link: '',
    };

    onChange(links.concat([newCustomLink]));
  };

  const handleDelete = (itemId: string) => {
    onChange(array.deleteById(links, itemId), true);
  };

  const handleFieldChange = (itemId: string, fieldName: string, value: string) => {
    onChange(array.updateFieldById(links, itemId, fieldName, value));
  };

  return (
    <StyledPaperContainer>
      <StyledSectionTitle>Footer custom links</StyledSectionTitle>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="footer-links">
          {(droppableProvided) => (
            <StyledCustomLinksList ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
              {links.map((item, i) => (
                <Draggable key={item.id} index={i} draggableId={item.id}>
                  {(draggableProvided, draggableSnapshot) => (
                    <FooterCustomLink
                      provided={draggableProvided}
                      snapshot={draggableSnapshot}
                      item={item}
                      error={getError()?.[i]}
                      onBlur={onBlur}
                      onFieldChange={handleFieldChange.bind(null, item.id)}
                      onDelete={handleDelete.bind(null, item.id)}
                    />
                  )}
                </Draggable>
              ))}
              {droppableProvided.placeholder}
            </StyledCustomLinksList>
          )}
        </Droppable>
        <div>
          <StyledTextButton onClick={handleAddMore}>+ Add More</StyledTextButton>
        </div>
      </DragDropContext>
    </StyledPaperContainer>
  );
};

export default FooterCustomLinks;
